import { takeLatest } from 'redux-saga/effects';
import { fetchProjectDetail } from 'collections/project';
import { taskCollection } from 'collections/tasks';
import { getProjectById } from 'data/projects/actions';
import { logger } from 'services';
function* getProjectByIdSaga({ payload }) {
    const { projectId, handleSuccess = ()=>{}, handleError = ()=>{} } = payload;
    try {
        if (projectId) {
            const project = yield fetchProjectDetail(projectId);
            const phases = project.projectPhases;
            let tasks = [];
            phases.map((p)=>{
                tasks = [
                    ...tasks,
                    ...p.tasks
                ];
                return p;
            });
            taskCollection.push(tasks, {
                source: 'fetch'
            });
            handleSuccess();
        } else {
            throw new Error('Project ID not found');
        }
    } catch (error) {
        logger.error('getProjectDetails failed', {
            error
        });
        handleError();
    }
}
export const watchGetProjectByIdSaga = function*() {
    yield takeLatest(getProjectById.type, getProjectByIdSaga);
};
